import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'
import moment from 'moment'
import momentDurationSetup from 'moment-duration-format'
import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import styled from 'styled-components'

import colors from '../../../../../lib/Colors'

momentDurationSetup(moment)

const TimeUntil = styled.span`
  font-size: 17px;
  font-weight: bold;
  color: ${(props) => {
    return props.variation === 'start' ? colors.green_300 : colors.red_200
  }};
  margin-left: 4px;
`
const StaticTime = styled.span`
  margin-left: 4px;
`

function DateHandler(props) {
  let [count, setCount] = useState(moment())
  let countTimeout = null

  useEffect(() => {
    const countdown = () => {
      clearTimeout(countTimeout)
      if (count > 0) {
        setCount(moment())
        // eslint-disable-next-line react-hooks/exhaustive-deps
        countTimeout = setTimeout(countdown, 1000)
      }
    }
    countdown()
    return () => {
      clearTimeout(countTimeout)
    }
  }, [])

  const expirationDate = moment(props.date, moment.ISO_8601)
  const formattedDate = moment
    .duration(expirationDate.diff(count))
    .format('d[d] h[h] mm[m] s[s]', { largest: 3 })

  if (moment().isBefore(moment(props.date))) {
    if (props.variation === 'start') {
      return (
        <Typography color="textSecondary" variant="body2">
          <span>{I18n.t('content.starts')}</span>
          <TimeUntil variation={props.variation}>{formattedDate}</TimeUntil>
          <br />
          <StaticTime>
            ({moment(props.date).format('L, ddd - h:mma')})
          </StaticTime>
        </Typography>
      )
    } else {
      return (
        <Typography color="textSecondary" variant="body2">
          <span>{I18n.t('content.ends')}</span>
          {props.isActivated && (
            <>
              <TimeUntil variation={props.variation}>{formattedDate}</TimeUntil>
              <div>
                <StaticTime>
                  ({moment(props.date).format('L, ddd - h:mma')})
                </StaticTime>
              </div>
            </>
          )}
          {!props.isActivated && (
            <StaticTime>
              {moment(props.date).format('L, ddd - h:mma')}
            </StaticTime>
          )}
        </Typography>
      )
    }
  } else {
    if (props.variation === 'start') {
      return (
        <Typography color="textSecondary" variant="body2">
          <span>{I18n.t('content.started')}</span>
          <StaticTime>{moment(props.date).format('L, ddd - h:mma')}</StaticTime>
        </Typography>
      )
    } else {
      return (
        <Typography color="textSecondary" variant="body2">
          <span>{I18n.t('content.ended')}</span>
          {props.isActivated && (
            <>
              <TimeUntil>{I18n.t('content.campaignOver')}</TimeUntil>
              <div>
                <StaticTime>
                  ({moment(props.date).format('L, ddd - h:mma')})
                </StaticTime>
              </div>
            </>
          )}
          {!props.isActivated && (
            <StaticTime>
              {moment(props.date).format('L, ddd - h:mma')}
            </StaticTime>
          )}
        </Typography>
      )
    }
  }
}

DateHandler.propTypes = {
  Date: PropTypes.string,
  isActivated: PropTypes.bool,
  variation: PropTypes.oneOf(['start', 'end']),
}

DateHandler.defaultProps = {
  variation: 'start',
  date: '1556125914410',
}

export default DateHandler
